import { render } from "./AddEditCscInspectionTankComponent.vue?vue&type=template&id=3b5c2f59"
import script from "./AddEditCscInspectionTankComponent.vue?vue&type=script&lang=js"
export * from "./AddEditCscInspectionTankComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__